module.exports = __webpack_public_path__ + "static/media/logo.c41c3a65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 120
// module chunks = 0